import { connect } from 'react-redux';
import React from 'react';
import Label from '@/component/form/Label.jsx';
import { List as DictList, mapDispatchToProps } from '../List';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';
import { Modal, Col, Row } from 'react-bootstrap';
import { MainComponentBox } from '../../../../util/util';
import { Button } from '../../../form/FormControls';
import RefPicker from '../select/DictPicker';
import { updateCarInsurance, loadCarInsurance } from './buyerCarInsurance.store';

class List extends DictList {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }

  componentWillMount() {
    super.componentWillMount();
    this.props.loadCarInsurance();
  }

  onBuyerChange = (values) => {
    const { insurancebuyers } = this.props;
    const insurancebuyersIds = insurancebuyers.map(b => b.get('value'));
    const valuesIds = values.map(v => v.value);
    const addedValues = values.filter(v => !insurancebuyersIds.includes(v.value));
    const removedValues = insurancebuyers.filter(val => val.get('value') != null
      && !valuesIds.includes(val.get('value')));
    this.props.updateCarInsurance(addedValues, removedValues.toJS());
  }

  handleAddAllInsurance = () => {
    const { insurancebuyers, refs } = this.props;
    const insurancebuyersIds = insurancebuyers.map(b => b.get('value'));
    const addedValues = refs
      .filter(ref => !insurancebuyersIds.includes(ref.get('id')))
      .map(e => e.set('value', e.get('id')).set('label', e.get('name')));
    this.props.updateCarInsurance(addedValues.toJS(), []);
  }

  render() {
    const { insurancebuyers } = this.props;
    return this.state.refs ?
      <div className="dict">
        <MainComponentBox>
          <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
            <Modal.Body>
              Are you sure you want to delete this element?
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.yesButton} id="delete_yes">Yes</Button>
              <Button onClick={this.closeModal} id="delete_no">No</Button>
            </Modal.Footer>
          </Modal>
          <Col
            md={8}
            sm={12}
            id="dictTable"
            className={'references-list'}
          >
            <Row>
              {super.render()}
            </Row>
          </Col>
          <Col
            sm={12} md={4}
            className={'report-panel cargo-insurance'}
          >
            <Label label="Cargo insurance" vertical sm={12}>
              <RefPicker
                updateDefValueOnEveryChange
                dict="buyer"
                name="buyer"
                multi
                defaultValue={insurancebuyers.toJS()}
                onChangeFunc={this.onBuyerChange}
              />
              <Button
                style={{ marginTop: 10 }}
                bsStyle={'primary'}
                onClick={this.handleAddAllInsurance}
                disabled={this.props.disabled}
              >Add all</Button>
            </Label>
          </Col>
        </MainComponentBox>
      </div>
      : <div></div>;
  }
}

const mapDispatchToPropsBuyer = dispatch => ({
  updateCarInsurance: (toAddInsurance, toRemoveInsurance) =>
    updateCarInsurance(dispatch, toAddInsurance, toRemoveInsurance),
  loadCarInsurance: () => loadCarInsurance(dispatch),
});
const mapStateToPropsBuyer = state => ({
  refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()),
  insurancebuyers: state.getIn(['references', 'values',
    REF_PATH, 'insurancebuyers'], new ImmutableList()),
});

export default connect(mapStateToPropsBuyer, dispatch => ({
  ...mapDispatchToPropsBuyer(dispatch),
  ...mapDispatchToProps(REF_NAME, REF_PATH)(dispatch),
}))(List);
